const _ = require('lodash');
const postal = require('postal');

class RicherRelevanceCarouselController {
    constructor(rrPlaceHolderCache, PageRouteToPlaceHolderMap, $state, carouselConfig, $rootScope, $timeout, $log, RREventFactory, decorateAdditionalDetails) {
        this.$onInit = function() {
            const vm = this;

            this.$onInit = function () {
                vm.refreshCrossSellType();
            };

            vm.isProductUrl = function () {
                return $state.current.url.includes('/product/');
            };

            vm.refreshCrossSellType = function () {
                vm.crossSellType = vm.isProductUrl() ? 'web:pdp' : null;
            };

            vm.RRclickEvent = function (linkUrl) {
                if (linkUrl) {
                    RREventFactory.clickItemEvent(linkUrl);
                }
            };

            vm.placeholder = {
                title: '',
                products: [],
                requiresRefresh: false,
                previousRefresh: undefined,
                previousProducts: [],
                refreshedOn: undefined,
                productCollection: undefined
            };

            vm.carousel = { config: carouselConfig, display: false, loading: true };

            const isUpdateToCurrentPlaceholder = (placeHolderToRefresh) => {
                const currentPlaceHolder = PageRouteToPlaceHolderMap[$state.current.name];
                return currentPlaceHolder === placeHolderToRefresh;
            };

            const clearPlaceholder = () => {
                vm.placeholder.requiresRefresh = false;
                vm.placeholder.products = [];
                vm.placeholder.previousProducts = [];
                vm.placeholder.title = '';
                vm.placeholder.previousRefresh = undefined;
                vm.placeholder.refreshedOn = undefined;
            };

            const rebindPlaceholder = (cachedPlaceHolder) => {
                const { products: latest, previousProducts: previous } = cachedPlaceHolder;
                const getProductId = (product) => {
                    return product.Stockcode;
                };
                const lastestIds = _.map(latest, getProductId);
                const previousIds = _.map(previous, getProductId);
                const difference = _.difference(lastestIds, previousIds);
                if (difference.length > 0) {
                    _.assign(vm.placeholder, cachedPlaceHolder);
                }
            };

            const updateCacheCopy = (cachedPlaceHolder, data) => {
                if (_.isUndefined(cachedPlaceHolder)) {
                    $log.error('You have a mismatch with the placeholder names');
                    return;
                }
                cachedPlaceHolder.previousRefresh = cachedPlaceHolder.refreshedOn;
                cachedPlaceHolder.refreshedOn = new Date().getTime();
                cachedPlaceHolder.title = data.title;
                cachedPlaceHolder.previousProducts = cachedPlaceHolder.products;
                cachedPlaceHolder.products = data.products;
            };

            const forceSlickRepaint = (placeholder, animationLength = 0) => {
                vm.placeholder.requiresRefresh = false;
                vm.carousel.loading = true;
                $timeout(() => {
                    rebindPlaceholder(placeholder);
                    vm.placeholder.requiresRefresh = true;
                    vm.carousel.loading = false;
                    if (vm.placeholder.products.length === 0) {
                        _.assign(vm.placeholder, placeholder);
                    }
                }, animationLength);
            };

            postal.subscribe({
                channel: 'richer-relevance-placeholder',
                topic: 'placement.#',
                callback: (data) => {

                    for (let i = 0; i < data.productsCollection.length; i++) {
                        decorateAdditionalDetails(data.productsCollection[i].Products);
                    }

                    vm.placeholder.productCollection = data.productsCollection;
                    const placeHolder = rrPlaceHolderCache[data.placeholder];
                    updateCacheCopy(placeHolder, data);
                    if (isUpdateToCurrentPlaceholder(data.placeholder)) {
                        forceSlickRepaint(placeHolder, 300);
                    }
                    //this is to let the subscribers know that the RR has been completed loading
                    $rootScope.$broadcast('RR:completed');
                }
            });

            $rootScope.$on('$stateChangeSuccess', (evt, to) => {
                // Check added to remove RR carousel from the page if
                // it has not been configured to be displayed
                const match = PageRouteToPlaceHolderMap[to.name];
                const showOnPage = !(_.isUndefined(match));
                clearPlaceholder();
                vm.carousel.display = showOnPage;
                vm.carousel.loading = true;
                vm.refreshCrossSellType();
            });
        };
    }
}

module.exports = function () {
    return {
        restrict: 'E',
        controller: ['rrPlaceHolderCache', 'PageRouteToPlaceHolderMap', '$state', 'carouselConfig', '$rootScope', '$timeout', '$log', 'RREventFactory', 'DecorateAdditionalDetails', RicherRelevanceCarouselController],
        controllerAs: 'ctrl',
        bindToController: true,
        link() {

        },
        template: require('./rr-carousel-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-carousel-directive.js
 **/